import React, { useState } from 'react';
import Icon from '../../../../components/AppIcon';
import Button from '../../../../components/ui/Button';
import Select from '../../../../components/ui/Select';
import { Checkbox } from '../../../../components/ui/Checkbox';

const SettingsModal = ({ isOpen, onClose, onSave, currentSettings }) => {
  const [settings, setSettings] = useState(currentSettings);

  const languageOptions = [
    { value: 'python', label: 'Python' },
    { value: 'javascript', label: 'JavaScript' },
    { value: 'java', label: 'Java' },
    { value: 'cpp', label: 'C++' },
    { value: 'sql', label: 'SQL' },
    { value: 'csharp', label: 'C#' }
  ];

  const difficultyOptions = [
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' }
  ];

  const handleSave = () => {
    onSave(settings);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black/40 z-[300] animate-fade-in"
        onClick={onClose}
      />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg z-[400] animate-scale-in">
        <div className="bg-card border border-border rounded-lg shadow-elevation-4 mx-4">
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="Settings" size={20} color="var(--color-primary)" />
              </div>
              <h2 className="text-xl font-heading font-semibold text-foreground">
                Interview Preferences
              </h2>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-md hover:bg-muted transition-colors duration-150 ease-out"
            >
              <Icon name="X" size={20} color="var(--color-foreground)" />
            </button>
          </div>

          <div className="p-6 space-y-6 max-h-[60vh] overflow-y-auto">
            <Select
              label="Default Programming Language"
              description="Your preferred language for coding interviews"
              options={languageOptions}
              value={settings?.defaultLanguage}
              onChange={(value) => setSettings({ ...settings, defaultLanguage: value })}
            />

            <Select
              label="Default Difficulty Level"
              description="Starting difficulty for new interviews"
              options={difficultyOptions}
              value={settings?.defaultDifficulty}
              onChange={(value) => setSettings({ ...settings, defaultDifficulty: value })}
            />

            <div className="space-y-3">
              <h3 className="text-sm font-medium text-foreground">Interview Options</h3>
              <Checkbox
                label="Enable voice feedback"
                description="Receive audio responses from the AI interviewer"
                checked={settings?.voiceFeedback}
                onChange={(e) => setSettings({ ...settings, voiceFeedback: e?.target?.checked })}
              />
              <Checkbox
                label="Show hints during interview"
                description="Display helpful hints when you're stuck"
                checked={settings?.showHints}
                onChange={(e) => setSettings({ ...settings, showHints: e?.target?.checked })}
              />
              <Checkbox
                label="Auto-save progress"
                description="Automatically save your interview progress"
                checked={settings?.autoSave}
                onChange={(e) => setSettings({ ...settings, autoSave: e?.target?.checked })}
              />
            </div>
          </div>

          <div className="flex gap-3 p-6 border-t border-border">
            <Button
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="default"
              fullWidth
              iconName="Check"
              iconPosition="left"
              onClick={handleSave}
            >
              Save Settings
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsModal;